import { Button, ColumnHeader, TextField } from '@deque/cauldron-react';
import React, { useEffect, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useAxeAccountAnalytics } from '~/common/contexts/analytics';
import { type Errors } from '~/common/utils/validate-password-settings-form';

interface PasswordAccountSettingsProps {
  handlePasswordSubmit?: (e: React.ChangeEvent<HTMLFormElement>) => void;
  currentPasswordRef?: React.RefObject<HTMLInputElement | null>;
  passwordRef?: React.RefObject<HTMLInputElement | null>;
  confirmPasswordRef?: React.RefObject<HTMLInputElement | null>;
  submitting?: boolean;
  errors: Errors;
}

const PasswordAccountSettings = ({
  handlePasswordSubmit,
  currentPasswordRef,
  passwordRef,
  confirmPasswordRef,
  submitting,
  errors
}: PasswordAccountSettingsProps): ReactElement => {
  const { t } = useTranslation();
  const analytics = useAxeAccountAnalytics();

  useEffect(() => {
    analytics.viewAccountSettingsPasswordPage();
  }, []);

  return (
    <>
      <ColumnHeader>
        <h2>{t('Password')}</h2>
      </ColumnHeader>
      <form onSubmit={handlePasswordSubmit}>
        <TextField
          label={t('Current Password')}
          name="currentPassword"
          type="password"
          error={errors.currentPassword}
          fieldRef={currentPasswordRef}
          autoComplete="current-password"
          required
        />
        <TextField
          label={t('New Password')}
          name="password"
          type="password"
          error={errors.password}
          fieldRef={passwordRef}
          autoComplete="new-password"
          required
        />
        <TextField
          label={t('Confirm Password')}
          name="confirmPassword"
          type="password"
          error={errors.confirmPassword}
          fieldRef={confirmPasswordRef}
          autoComplete="new-password"
          required
        />
        <Button type="submit" disabled={submitting}>
          {t('Save')}
        </Button>
      </form>
    </>
  );
};

export default PasswordAccountSettings;
